<template>
  <div class="col backgroundForm">
  
  <div class="form-row" v-if=" (cDtsUser.roleAssign !== 'OPERADOR CAPITANIA' && cDtsUser.roleAssign !== 'FINANCIERO') ">
    <div class="form-group col-12 col-md-4 offset-md-4">
        <label for="nombre_embarcacion">Capitania</label>  
                            <!-- listar las capitanias -->
          <select name="captain_ordop" class="form-control" id="captain_ordop" v-model="captain_location" @change="mShowJurisdiccion">
            <option v-for="port in ports" :value="port" :key="port.id">{{ port.name_port }}</option>
          </select>                         
    </div>
    <div class="col-12" align="center">
        <button class="btn btn-info" @click="mShowJurisdiccion"><font-awesome-icon icon="eye" /> Mostrar Jurisdiccion</button>
        <button class="btn btn-success" @click="mModalList"><font-awesome-icon icon="eye" /> Datos</button>
    </div>



  </div>
  <br>

  <CargarMapa
    v-if="renderComponent"
    :configMapa="configMapa"
    apiKey="AIzaSyDQ4Ii0YR8i1LCRjgK9rfoDxVvE2S9__tU"

  >

    <template slot-scope="{ google, map }">
      
      <NuevoMarcador
        v-for="markers in cNewLocationJurisdiccion"
          ref="newMark"
          :key="markers.id"
          :marker=markers
          :google="google"
          :map="map"

      />

    </template>

  </CargarMapa>
    <div class="modal fade" :id="idModalView" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
                
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalCenterTitle">{{ captain_location.name_port }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                </div>
                <div class="modal-body table-responsive-xl">
                    <table class="table table-hover">
                      <thead>
                        <tr>
                          <th width="5%">#Id</th>
                          <th width="30%">Localidad</th>
                          <th width="40%">Descripcion</th>
                          <th width="20%">Opciones</th>
                        </tr>
                      </thead>
                      <tbody v-for="nj in cNewLocationJurisdiccion" :key="nj.id">
                        <tr v-if="nj.id !== 0">

                            <td>{{ nj.id }}</td>
                            <td><span v-if="!nj.edit"> {{ nj.localidad }}</span> <input type="text" class="form-control" v-model="editLocation.localidad" autocomplete="off" v-else></td>
                            <td><span v-if="!nj.edit">{{ nj.description }}</span> <textarea type="text" class="form-control" v-model="editLocation.description" autocomplete="off" v-else></textarea> </td>
                            <td v-if="!nj.edit"> <button class="btn btn-warning" @click="mEditPosition(nj)"><font-awesome-icon icon="edit" data-toggle="tooltip" data-placement="bottom" title="Editar Campo" /></button> <button class="btn btn-danger" @click="mDeletePosition(nj)" data-toggle="tooltip" data-placement="bottom" title="Eliminar Dato"><font-awesome-icon icon="minus-circle" /></button> </td>
                            <td v-else><button class="btn btn-primary" @click="mSaveEditPosition" data-toggle="tooltip" data-placement="bottom" title="Actualizar registro"><font-awesome-icon icon="sync-alt" /></button> <button class="btn btn-danger" @click="mCancelEditPosition" data-toggle="tooltip" data-placement="bottom" title="Cancelar Edicion"><font-awesome-icon icon="times-circle" /></button></td>
                          
                        </tr>
                      </tbody>
                    </table>
                </div>
                <div class="modal-footer">
                        <button type="button" class="btn btn-success" data-dismiss="modal" @click="mSaveJurisdiccion"><font-awesome-icon icon="save" /></button>

                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="mCancelEditPosition"><font-awesome-icon icon="times-circle" /></button>
                </div>
                
            </div>
        </div>
    </div>

    <modalLoading :id="id_loading" :title="title_loading"></modalLoading>
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  const qs= require('qs');

  import modalLoading from '../modal/modalLoading';
  import modalView from '../modal/modalView';

  import CargarMapa from "./LoadMap";
  import Marcadores from "./MarksMaps";
  import NuevoMarcador from './NewMarkJurisdiccion';

  import { configMapa } from "@/constants/configMapa";
  export default {
    components: {
      CargarMapa,
      Marcadores,
      NuevoMarcador,
      modalView,
      modalLoading
    },
    mounted(){
      this.mCallJurisdiccion();
    },
    data() {
      return {
        id_loading:'modalLoadingJuris',
        title_loading:'Actualizando',
        send_dispatch:true,
        renderComponent:false,
        ports:[],
        captain_location:{
          id:0,
          name_port:null
        },
        juris:[],
        contentModal:'',
        idModalView:'idModalListMarks',
        titleModal:'',
        editLocation:{
          id:0,
          localidad:null,
          description:null,
          edit:false
        }
      }
    },
    methods:{
      mvalidateJurisdicciones(){
        // verificamos que las jurisdicciones cuenten con descripcion
        let veri=false;
        this.cNewLocationJurisdiccion.forEach((val, index)=>{
          if( val.localidad === null || val.localidad === '' || val.description === null || val.description === '' ){
            veri=true;
            toastr.warning(`Indique una breve descripcion y localidad en el registro ${val.id}`);
          }
        })
        return veri;
      },
      mSaveJurisdiccion(){
        console.log('guardamos las jurisdicciones de una capitania de puerto.')
        if(!this.mvalidateJurisdicciones()){  
          let message = {
                title: `Actualizar la Jurisdiccion`,
                body: `¿Desea Actualizar la jurisdiccion de la capitania de puerto ${this.captain_location.name_port}?`
            };        
                
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                
                npr.then(async (msg)=>{
                    if(msg){
                        // registramos y validamos el presupuesto general en la bd
                        try {
                            this.activeModal(this.id_loading);
                            console.log('se manda la actualizacion al sistema')
                            let jurisdicciones=[];
                            let aux_juris=this.cNewLocationJurisdiccion;
                            aux_juris.forEach(ju=>{
                              if(ju.id!==0){
                                // recien vaciamos los datos al array
                                jurisdicciones.push(ju);
                              }
                            });
                            let juris={aux_juris:jurisdicciones}
                            // console.log(jurisdicciones);
                            let new_jur=await axios.post(`updateJurisdiccion/${this.captain_location.id}?api_token=${Vue.auth.getToken()}`, qs.stringify(juris));
                            if(new_jur.data.status){
                              this.mCallJurisdiccion();
                              toastr.success(`${new_jur.data.response}`, 'Exito')
                            }else{
                              toastr.warning(`${new_jur.data.response}`, 'Error')
                            }
                            setTimeout(()=>{
                              this.inactiveModal(this.id_loading);
                            }, 2000)
                        }catch(err){
                            console.log('error al registrar');
                            setTimeout(()=>{
                                toastr.error('Ha ocurrido un error en el proceso', 'Error')
                                this.inactiveModal(this.id_loading);
                            }, 3000)
                        }
                    }else{
                        console.log('No se guardo la ordop')
                        // console.log(this.dts_ordop);
                    }
                })
            }else{
                console.log('debe validarse los campos')
            }
      },
      mEditPosition(v){        
        // console.log(v);
        if(!this.editLocation.edit){
          this.$store.dispatch('sGoogleMaps/editMarkerJurisdiccion', v.id);
          this.editLocation.id=v.id;
          this.editLocation.localidad=v.localidad;
          this.editLocation.description=v.description;
          this.editLocation.edit=true;
        }else{
          this.$store.dispatch('sGoogleMaps/cancelEditMarkerJurisdiccion', v.id);  
          this.$store.dispatch('sGoogleMaps/editMarkerJurisdiccion', v.id);
          this.editLocation.id=v.id;
          this.editLocation.localidad=v.localidad;
          this.editLocation.description=v.description;
          this.editLocation.edit=true;
        }        
      },
      mCancelEditPosition(){
        this.$store.dispatch('sGoogleMaps/cancelEditMarkerJurisdiccion', true);
        this.editLocation.id=0;
        this.editLocation.localidad=null;
        this.editLocation.description=null;
      },
      mDeletePosition(v){
        // eliminamos el valor buscado
        this.$store.dispatch('sGoogleMaps/deleteMarkersJurisdiccion', v.id);
        // forzamos la visualizacion de los datos
        this.forceRerender();
      },
      mSaveEditPosition(){
        console.log('guardamos los datos de ubicacion y direccion');
        this.$store.dispatch('sGoogleMaps/saveMarkerJurisdiccion', this.editLocation);
      },
      mValidateNewLocation(){
        if(this.captain_location.id===0){
          toastr.error('Seleccione una Capitania', 'Error');
          return false;
        }
        return true;
      },
      async mCallJurisdiccion(){
        
        let cp=await axios.get(`getPortsComplete?api_token=${Vue.auth.getToken()}`);
        let cpj=await axios.get(`getJurisdiccion?api_token=${Vue.auth.getToken()}`);
        // console.log(cp);

        let juris_aux=cpj.data;

        this.ports=cp.data;
        this.juris=cpj.data;
      },
      mShowJurisdiccion(){
        // debemos vaciar el storage los datos y de ahi bajar los datos
        this.$store.dispatch('sGoogleMaps/deleteAllMarkersjurisdiccion', true);
        // llenar el storage
        if(this.captain_location.id>0){
          // indicamos el array que contendra los nuevos marcadores
          let marksCaptain=[];
          // si realizamos el cargado de los datos
          let icap=this.ports.findIndex(cpb => cpb.id === this.captain_location.id);
          
          // let lat=this.mConvertRadial(this.ports[icap].latitud);
          // let lon=this.mConvertRadial(this.ports[icap].longitud);

          // aca colocamos el primer indice que seria la ubicacion de la capitania
          let location={
              id:0,
              position:{lat:parseFloat(this.ports[icap].latitud), lng:parseFloat(this.ports[icap].longitud)},
              title:`${this.ports[icap].category_port} ${this.ports[icap].name_port}`,
              label:`0`,
              localidad:`capitania`,
              description:`capitania`,
              edit:false              
            }
          marksCaptain.push(location);
          // ahora anadimos la jurisdiccion a partir del id 1
          let code=0;
          let caracteres = "abcdefghijkmnpqrtuvwxyzABCDEFGHJKMNPQRTUVWXYZ2346789";
          let cont_a=0;
          this.juris.forEach( (cpp,index) =>{
            
            if(cpp.id_capitania===this.captain_location.id){
                cont_a+=1;
                code=caracteres.charAt(Math.floor(Math.random()*caracteres.length)) + caracteres.charAt(Math.floor(Math.random()*caracteres.length))+cont_a;
                // console.log(cont_a)
                
                let location={
                  id:code,
                  position:{lat:parseFloat(cpp.latitud), lng:parseFloat(cpp.longitud)},
                  title:`${code}`,
                  label:`${code}`,
                  localidad:`${cpp.localidad}`,
                  description:`${cpp.descripcion}`,
                  edit:false
                }
              marksCaptain.push(location);
              }
          })
          // aca mandamos al store los datos
          this.$store.dispatch('sGoogleMaps/addMarkersJurisdiccion', marksCaptain);
          this.forceRerender();
        }else{
          toastr.warning('Seleccione una capitania de puerto', 'Advertencia');
        }
      },
      async mSaveNewLocation(){
            // validar los datos
            if(this.mValidateNewLocation()){
                // enviar los datos al servidor
                let message = {
                    title: 'Actualizacion Ubicacion',
                    body: `¿Desea Actualizar la Ubicacion de la Capitania ${this.captain_location.name_port}?`
                }
                
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                
                npr.then(async (msg)=>{
                    if(msg){
                        // registramos el proceso de la ordop
                        try {
                            
                            let pos={
                              lat:this.cNewLocationPosition.lat,
                              lng:this.cNewLocationPosition.lng
                            }
                            let dtsLocation={
                              id:this.captain_location.id,
                              position:JSON.stringify(pos)
                            }

                            console.log(dtsLocation);
                            // this.activeModal(this.id_modal_progress);
                            // this.process_ordop.load=JSON.stringify(this.loads_declare);
                            let u_location_captain=await axios.post(`updateCaptainLocation?api_token=${Vue.auth.getToken()}`, qs.stringify(dtsLocation));
                            setTimeout(()=>{                                
                                if(u_location_captain.data.status){
                                    toastr.success(u_location_captain.data.respuesta);
                                    // detenemos la animacion                                    
                                }
                            },1000)

                        }catch(err){
                            console.log('error al registrar');
                        }
                    }else{
                        console.log('No se guardo la nueva lozalizacion de la capitania')
                        // console.log(this.s_pro_ordop);
                    }
                })
            }else{
                console.log('debe validarse los campos')
            }            
      },
      forceRerender() {
        // Remove my-component from the DOM
        this.renderComponent = false;

        // also use nextTick this way
        this.$nextTick().then(() => {
        // Add the component back in
          this.renderComponent = true;
        });
      },
      mModalList(){
        console.log(this.cNewLocationJurisdiccion);
        if(this.cNewLocationJurisdiccion.length > 0){
          // this.contentModal='<h1>Si hay datos</h1><button onclick="mVerDatos(1)"></button>';
          this.activeModal(this.idModalView);
        }else{
          toastr.warning('Elija una Capitania de Puerto', 'Advertencia');
        }
      },
      mVerDatos(e){
        console.log(`el valor que llego es ${e}`);
      },
      activeModal(e){
        $(`#${e}`).modal('show');
      },
      inactiveModal(e){
        $(`#${e}`).modal('hide');
      }
    },
    computed: {
      configMapa() {
        return {
          ...configMapa,
          center: this.mapCenter
        };
      }, 
      cDtsUser(){
        return this.$store.getters.getUserState;
      },     
      cNewLocationJurisdiccion(){
        // return this.$store.getters.getLocation;
        // console.log(this.$store.getters['sGoogleMaps/getLocation'].lat);
        return this.$store.getters['sGoogleMaps/getMarkersJurisdiccion'];
      },
      cNewLocation(){
        return this.$store.getters['sGoogleMaps/getLocation'];
      },
      mapCenter() {
        // return this.markers[0].position;
        return this.cNewLocationJurisdiccion[0].position;
      },
    }
  };
  
</script>


// WEBPACK FOOTER //
// src/components/maps/NewLocationJurisdiccion.vue